import {
  AccountAttributeUpdateAction,
  computeInverseAccountAttributeUpdateAction,
} from '../../../../helpers/models/accountAttributeUpdateHelpers';
import {ThunkAsyncAction} from '../../../appThunk';
import {updateAccountAttributeAsyncAction} from '../../../data/accounts/accountsActions';
import {getAccounts} from '../../../data/dataSelectors';
import {AppPanelId} from '../../panelStateBase';
import {removeBannerAction} from './bannersActions';
import {AccountDetailsUndoBannerState} from './bannersState';

/*
 * Actions.
 */

export function undoAccountDetailsBannerAction(
  panelId: AppPanelId,
  banner: AccountDetailsUndoBannerState,
): ThunkAsyncAction {
  return async (dispatch, getState) => {
    const account = getAccounts(getState())[banner.accountId];
    if (!account) {
      return;
    }

    const action = banner.action as AccountAttributeUpdateAction;

    const inverseAction = computeInverseAccountAttributeUpdateAction(action);
    dispatch(updateAccountAttributeAsyncAction(account, inverseAction));

    // Hide the banner from the UI.
    dispatch(removeBannerAction(panelId, banner.uid));
  };
}
